export function validateAddress(value) {
  let error;
  if (value === null || value === "") {
    error = "Address is Required";
  }
  return error;
}

export function validateAge(value) {
  let error;
  if (value === null || value === "") {
    error = "Age is Required";
  }
  return error;
}

export function validateConfirmPassword(password, confirmPassword) {
  let error;
  if (confirmPassword === null) {
    error = "Password is Required";
  }

  if (confirmPassword !== password) {
    error = "Passwords Do Not Match";
  }

  return error;
}

export function validateEmail(value) {
  let error;
  if (!value) {
    error = "Email is Required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = "Invalid Email Address";
  }
  return error;
}

export function validateFirstName(value) {
  let error;
  if (value === null || value === "") {
    error = "First Name is Required";
  }
  return error;
}

export function validateLastName(value) {
  let error;
  if (value === null || value === "") {
    error = "Last Name is Required";
  }
  return error;
}

export function validateMessage(value) {
  let error;
  if (value === null) {
    error = "Message is Required";
  }
  return error;
}

export function validateName(value) {
  let error;
  if (value === null || value === "") {
    error = "Name is Required";
  }
  return error;
}

export function validateNumber(value) {
  let error;
  if (value === null) {
    error = "Required";
  }
  if (value < 0) {
    error = "Value must be a positive number";
  }
  return error;
}

export function validatePassword(value) {
  let error;
  if (value === null) {
    error = "Password is Required";
  }
  return error;
}

export function validateRequired(value) {
  let error;
  if (value === null) {
    error = "Required";
  }
  return error;
}

export function validateSubject(value) {
  let error;
  if (value === null) {
    error = "Subject is Required";
  }
  return error;
}

export function validateTextField(value) {
  let error;
  if (value === null) {
    error = "Required";
  }
  return error;
}
